import { NbMenuItem } from '@nebular/theme';

export const MENU_ITEMS: NbMenuItem[] = [
  {
    title: 'menu.dashboard',
    icon: 'home-outline',
    link: '/pages/dashboard',
    home: true,
    data: { permissionKey: 'Dashboard' },
  },
  {
    title: 'menu.quickSettings',
    icon: 'settings-outline',
    link: '/pages/settings',
    data: { permissionKey: 'Settings' },
  },
  // Notifications (commented until backend is ready - uncomment when API is set up)
  // {
  //   title: 'Notifications',
  //   icon: 'bell-outline',
  //   link: '/pages/notifications',
  // },
  {
    title: 'menu.reports',
    icon: 'credit-card-outline',
    data: { permissionKey: 'Reports' },
    children: [
      {
        title: 'menu.masterReport',
        link: '/pages/report/master-report',
      },
      {
        title: 'menu.saleSummary',
        link: '/pages/salesummary',
      },
      {
        title: 'menu.terminalReport',
        link: '/pages/terminal-report',
      },
      {
        title: 'menu.productSales',
        link: '/pages/salereport',
      },
      {
        title: 'menu.productSaleCostReport',
        link: '/pages/report/product-sale-cost-report',
      },
      {
        title: 'menu.comboSalesReport',
        link: '/pages/comboreport',
      },
      {
        title: 'menu.saleFeed',
        link: '/pages/salefeed',
      },
      {
        title: 'menu.departmentWiseSales',
        link: '/pages/report/department-wise-sales',
      },
      {
        title: 'menu.departmentWiseProductSales',
        link: '/pages/report/productsales',
      },
      {
        title: 'menu.shiftReport',
        link: '/pages/shift-report',
      },
      {
        title: 'menu.cashInOutReport',
        link: '/pages/cash-in-out-report',
      },
      {
        title: 'menu.costBySalesReport',
        link: '/pages/cost-report',
      },
      
      {
        title: 'menu.hourlyReport',
        link: '/pages/hourly-report',
      },
      {
        title: 'menu.onlineOrdersReport',
        link: '/pages/online-order/reports',
      },
      {
        title: 'menu.eodCashup',
        link: '/pages/eod-cashup',
      },
      {
        title: 'menu.customerJournalReport',
        link: '/pages/customers/reports',
      },
      {
        title: 'menu.customerTransactions',
        link: '/pages/report/customertransactions',
      },
      {
        title: 'menu.cashDrawerLog',
        link: '/pages/cash-drawer',
      },
      {
        title: 'menu.discountReport',
        link: '/pages/discount-report',
      },
      {
        title: 'menu.voidReport',
        link: '/pages/report/void-report',
      },
      {
        title: 'menu.couponReport',
        link: '/pages/report/coupon-report',
      },
      {
        title: 'menu.voucherReport',
        link: '/pages/report/voucher-report',
      },
      {
        title: 'menu.staffReport',
        link: '/pages/report/staff-report',
      },
      {
        title: 'menu.reportCategories',
        link: '/pages/report/report-categories',
      },
    ],
  },
  {
    title: 'menu.menu',
    icon: 'layout-outline',
    data: { permissionKey: 'Menu' },
    children: [
      {
        title: 'menu.productList',
        link: '/pages/products',
      },
      {
        title: 'menu.menuSetup',
        link: '/pages/menu/setup',
      },
      {
        title: 'menu.visibilityManager',
        link: '/pages/menu-management/visibility',
      },
      // {
      //   title: 'menu.menuManage',
      //   link: '/pages/menu-management',
      // },
     
      // {
      //   title: 'menu.productListPaginated',
      //   link: '/pages/products/paginated',
      // },
      {
        title: 'menu.priceManager',
        link: '/pages/menu/price-manager',
      },
      {
        title: 'menu.superCategories',
        link: '/pages/categories/super-categories',
      },
      {
        title: 'menu.productCategories',
        link: '/pages/categories',
      },
      {
        title: 'menu.productSubcategories',
        link: '/pages/subcategories',
      },
      {
        title: 'menu.combos',
        link: '/pages/menu/combo',
      },
      {
        title: 'menu.productCombos',
        link: '/pages/menu/product-combos',
      },
      {
        title: 'menu.combosCategories',
        link: '/pages/menu/combo/categories',
      },
      {
        title: 'menu.productSizes',
        link: '/pages/products/sizes',
      },
      {
        title: 'menu.quickNotes',
        link: '/pages/quicknotes',
      },
      {
        title: 'menu.modifiers',
        link: '/pages/modifiers',
      },
      {
        title: 'menu.modifiersCategory',
        link: '/pages/modifiercategory',
      },
      {
        title: 'menu.productInventory',
        link: '/pages/menu/product-inventory',
      },
      {
        title: 'Label Printing',
        link: '/pages/menu-management/label-printing',
      },
      {
        title: 'Menu Tags',
        link: '/pages/menu-management/menu-tags',
      },
      {
        title: 'menu.priceTags',
        link: '/pages/menu/pricetag',
      },
      {
        title: 'Pricetag Ordering',
        link: '/pages/pricetags/ordering',
      },
      {
        title: 'menu.courses',
        link: '/pages/menu/courses',
      },
    ],
  },
  // {
  //   title: 'menu.gridButtons',
  //   link: '/pages/grid-buttons',
  //   icon: 'grid-outline',
  //   data: { permissionKey: 'Menu' },
  // },
  {
    title: 'menu.inventory',
    icon: 'shopping-bag-outline',
    data: { permissionKey: 'Inventory' },
    children: [
      {
        title: 'menu.inventoryItems',
        link: '/pages/inventory',
      },
      {
        title: 'menu.stockValueReport',
        link: '/pages/inventory/report',
      },
      {
        title: 'menu.inventoryCategories',
        link: '/pages/inventory/categories',
      },
      {
        title: 'menu.suppliersOrders',
        link: '/pages/Suppliers',
      },
      {
        title: 'menu.purchaseInvoice',
        link: '/pages/purchase-invoice',
      },
      {
        title: 'menu.orderingLevel',
        link: '/pages/inventory/ordering-level',
      },
      {
        title: 'menu.stockAlert',
        link: '/pages/inventory/stock-alert',
      },
      {
        title: 'menu.stockMovement',
        link: '/pages/inventory/stock-movement',
      },
      {
        title: 'menu.stockHistory',
        link: '/pages/inventory/stock-history',
      },
      {
        title: 'menu.stockTake',
        link: '/pages/stocktake',
      },
      {
        title: 'menu.stockTakeLogs',
        link: '/pages/stocktake/logs',
      },
      {
        title: 'menu.stockLists',
        link: '/pages/inventory/stock-list',
      },
      {
        title: 'menu.wastageCreate',
        link: '/pages/wastages',
      },
      {
        title: 'menu.wastageLogs',
        link: '/pages/wastages/logs',
      },
      {
        title: 'menu.inventoryProductMapping',
        link: '/pages/inventoryproductmapping',
      },
      {
        title: 'menu.inventorySettings',
        link: '/pages/inventory/settings',
      },
    ],
  },
  
  {
    title: 'menu.promotions',
    icon: 'gift-outline',
    data: { permissionKey: 'Promotions' },
    children: [
      {
        title: 'menu.promotion',
        link: '/pages/promotions',
      },
      {
        title: 'menu.customerPromotion',
        link: '/pages/promotions/customer',
      },
      {
        title: 'menu.coupons',
        link: '/pages/coupons',
      },
      {
        title: 'menu.offers',
        link: '/pages/promotions/offers',
      },
      {
        title: 'menu.offersGeneratedCoupons',
        link: '/pages/promotions/offer-generated-coupons',
      },
      {
        title: 'menu.offerTransactions',
        link: '/pages/promotions/offer-transactions',
      },
    ]
  },
  {
    title: 'menu.onlineOrder',
    icon: 'smartphone-outline',
    data: { permissionKey: 'OnlineOrder' },
    children: [
      {
        title: 'menu.orders',
        link: '/pages/online-order/orders',
      },
      {
        title: 'menu.settings',
        link: '/pages/online-order/settings',
      },
      {
        title: 'menu.scheduledDisable',
        link: '/pages/online-order/online-scheduled-disable',
      },
      {
        title: 'menu.paymentGateways',
        link: '/pages/online-order/payment-gateways',
      },
      {
        title: 'menu.orderIntegrations',
        link: '/pages/online-order/integrations',
      },
      {
        title: 'menu.deliveryZones',
        link: '/pages/online-order/delivery-zones',
      },
      {
        title: 'menu.serviceHours',
        link: '/pages/online-order/opening-hours',
      },
      {
        title: 'menu.deliveryIntegrations',
        link: '/pages/online-order/delivery-integration',
      },
      {
        title: 'menu.deliveryReport',
        link: '/pages/online-order/external-delivery-report',
      },
      {
        title: 'menu.cartSuggestions',
        link: '/pages/online-order/cart-suggestions',
      },
      {
        title: 'menu.pushNotifications',
        link: '/pages/online-order/push-notifications',
      },
      {
        title: 'menu.onlineMenuStatus',
        link: '/pages/online-order/online-menu-status',
      },
    ]
  },
  {
    title: 'menu.tableSetup',
    icon: 'grid-outline',
    data: { permissionKey: 'TableSetup' },
    children: [
      {
        title: 'menu.tables',
        link: '/pages/postables',
      },
      {
        title: 'menu.tableBookings',
        link: '/pages/table-reservations',
      },
      {
        title: 'menu.tableGroup',
        link: '/pages/tablegroups',
      },
      {
        title: 'menu.tableSideOrdering',
        link: '/pages/table-side-ordering'
      },
      {
        title: 'menu.qrCode',
        link: '/pages/qr-code'
      },
      
      {
        title: 'menu.reservationSettings',
        link: '/pages/services/table-reservation',
      },
    ]
  },
  {
    title: 'menu.payments',
    icon: 'credit-card-outline',
    data: { permissionKey: 'Payments' },
    children: [
      {
        title: 'menu.paymentType',
        link: '/pages/pamenttypes',
      },
      {
        title: 'menu.discounts',
        link: '/pages/discounts',
      },
      {
        title: 'menu.surcharges',
        link: '/pages/surcharges',
      },
    ]
  },
  {
    title: 'menu.users',
    icon: 'person-outline',
    data: { permissionKey: 'Users' },
    children: [
      {
        title: 'menu.user',
        link: '/pages/users',
      },
      {
        title: 'menu.userSettings',
        link: '/pages/users/settings',
      },
      {
        title: 'menu.roles',
        link: '/pages/roles',
      },
    ],
  },
  {
    title: 'menu.timesheet',
    icon: 'clipboard-outline',
    link: '/pages/attendance-report',
    data: { permissionKey: 'Timesheet' },
  },
  {
    title: 'menu.settings',
    icon: 'settings-2-outline',
    data: { permissionKey: 'Settings' },
    children: [
      {
        title: 'menu.quickSettings',
        link: '/pages/settings',
      },
      {
        title: 'menu.storeSettings',
        link: '/pages/user-basics',
      },
      {
        title: 'menu.emailNotifications',
        link: '/pages/user-basics/email-notifications',
      },
      {
        title: 'menu.invoiceSettings',
        link: '/pages/online-order/invoice',
      },
      {
        title: 'menu.whatsappAlerts',
        link: '/pages/user-basics/whatsapp-alerts',
      },
      {
        title: 'menu.location',
        link: '/pages/user-basics/map',
      },
      {
        title: 'menu.reportSettings',
        link: '/pages/settings/report-settings',
      },
      {
        title: 'menu.voidReasons',
        link: '/pages/voidreason',
      },
      {
        title: 'menu.cashInOutReasons',
        link: '/pages/settings/cashinoutreasons',
      },
    ]
  },
  {
    title: 'menu.customers',
    icon: 'people-outline',
    link: '/pages/customers',
    data: { permissionKey: 'Customers' },
    children: [
      {
        title: 'menu.manage',
        link: '/pages/customers',
      },
      {
        title: 'menu.reports',
        link: '/pages/customers/reports',
      },
      {
        title: 'menu.membershipTypes',
        link: '/pages/customers/membership_types',
      },
      {
        title: 'menu.marketingConsents',
        link: '/pages/customers/marketing_consents',
      },
    ]
  },
  {
    title: 'menu.loyaltyProgram',
    icon: 'award-outline',
    link: '/pages/loyalty-program',
    data: { permissionKey: 'Customers' },
  },
  {
    title: 'menu.kiosk',
    icon: 'archive-outline',
    link: '/pages/kiosk',
    data: { permissionKey: 'Kiosk' },
    children: [
      {
        title: 'menu.images',
        link: '/pages/kiosk/images',
        icon: 'image-outline',
      },
      {
        title: 'menu.kioskCartSuggestions',
        link: '/pages/kiosk/cart-suggestions',
        icon: 'shopping-cart-outline',
      }
    ]
  },
  {
    title: 'menu.customerDisplay',
    icon: 'tv-outline',
    link: '/pages/customer-display',
    data: { permissionKey: 'Kiosk' },
  },
  {
    title: 'menu.websiteBuilder',
    icon: 'globe-outline',
    link: '/pages/websitebuilder',
    data: { permissionKey: 'OnlineOrder' },
  },
  {
    title: 'menu.help',
    icon: 'question-mark-circle-outline',
    children: [
      {
        title: 'menu.issues',
        link: '/pages/issues',
      },
      {
        title: 'menu.about',
        link: '/pages/help/about',
      },
    ],
  },
  {
    title: 'menu.auth',
    icon: 'lock-outline',
    children: [
      {
        title: 'menu.login',
        link: '/auth/login',
      },
      {
        title: 'menu.register',
        link: '/auth/register',
      },
      {
        title: 'menu.requestPassword',
        link: '/auth/request-password',
      },
      {
        title: 'menu.resetPassword',
        link: '/auth/reset-password',
      },
    ],
  },
]; 